// src/icons/LowStockIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function LowStockIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 13,
    viewBox: "0 0 13 13",
    width: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        clipRule: "evenodd",
        d: "M6.09245 0.00533208L5.7784 0.0378765C4.25451 0.190021 2.71923 0.975968 1.68106 2.13618C0.53306 3.41924 -0.0502981 5.01147 0.00340016 6.70785C0.0969653 9.63766 2.11065 12.1184 4.96723 12.8246C5.80828 13.0277 6.68128 13.0618 7.5356 12.9249C8.38993 12.788 9.20858 12.4829 9.94408 12.0272C11.3905 11.126 12.4258 9.69346 12.8275 8.03728C12.9675 7.46694 13 7.17649 13 6.502C13 5.82752 12.9675 5.53706 12.8275 4.96672C12.1831 2.3347 10.0157 0.398305 7.31856 0.045199C7.0875 0.0150954 6.24704 -0.0117537 6.09245 0.00533208ZM7.19896 1.2648C8.11287 1.38511 8.97964 1.74152 9.71383 2.2989C9.98151 2.49905 10.5079 3.02545 10.7081 3.29313C11.1645 3.90415 11.5021 4.62257 11.6551 5.31007C11.8292 6.09515 11.8292 6.90886 11.6551 7.69394C11.3183 9.20807 10.2516 10.5522 8.83757 11.2437C8.32778 11.4932 7.78244 11.6623 7.22093 11.7449C6.87596 11.7978 6.13395 11.7978 5.78898 11.7449C4.20407 11.5041 2.86649 10.6392 2.02441 9.30977C1.81728 8.96635 1.6445 8.60335 1.50858 8.22604C1.31478 7.67223 1.21978 7.08869 1.22788 6.502C1.22788 5.65666 1.39142 4.93581 1.75347 4.19135C2.0301 3.62345 2.31161 3.23129 2.77293 2.76998C3.18096 2.34675 3.6626 2.00131 4.1943 1.75052C5.12591 1.29544 6.17142 1.12643 7.19896 1.2648ZM6.26575 3.48351C6.0835 3.54291 5.98018 3.64705 5.92973 3.82116C5.90044 3.92042 5.89719 4.14742 5.90207 5.53869C5.90858 7.1415 5.90858 7.14231 5.95577 7.231C6.01776 7.3446 6.11726 7.43317 6.23728 7.48159C6.34467 7.51902 6.66524 7.51902 6.77263 7.48159C6.89265 7.43317 6.99214 7.3446 7.05414 7.231C7.10133 7.14231 7.10133 7.1415 7.10784 5.53869C7.11435 3.7878 7.11435 3.78618 6.98987 3.63891C6.88898 3.5185 6.78077 3.47863 6.5375 3.47212C6.44676 3.46701 6.35574 3.47082 6.26575 3.48351ZM6.33084 8.56044C6.16806 8.61865 6.03267 8.7352 5.95089 8.88751C5.89215 9.03343 5.88497 9.19502 5.93055 9.34557C5.97454 9.46344 6.0527 9.5655 6.15503 9.6387C6.25735 9.71189 6.37919 9.75289 6.50495 9.75644C6.75148 9.75644 7.00288 9.57745 7.07936 9.34557C7.12494 9.19502 7.11776 9.03343 7.05902 8.88751C6.99167 8.76865 6.89396 8.66982 6.77589 8.60112C6.68151 8.5523 6.42685 8.52871 6.33084 8.56044Z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    ]
  });
}
export {
  LowStockIcon
};
//# sourceMappingURL=LowStockIcon.mjs.map